import React from "react";

const WorldCanvas: React.FC = () => {
    return (<>
        {/*<p>Здесь будет отображение открытого мира</p>*/}
    </>)
}

export default WorldCanvas;